module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 79.0836fc61.png";